import { makeStyles } from 'tss-react/mui';
import { MediaFormatEnum } from '../../../modules/general-settings/enums/mediaFormat.enum';

export const PRODUCTS_ADDED_CARD_HEIGHT: Record<MediaFormatEnum, number> = {
  [MediaFormatEnum.SQUARE]: 65,
  [MediaFormatEnum.RECTANGULAR]: 80,
};

const AVATAR_WIDTH: Record<MediaFormatEnum, number> = {
  [MediaFormatEnum.SQUARE]: 65,
  [MediaFormatEnum.RECTANGULAR]: 55,
};

const AVATAR_BORDER_RADIUS = 8;
const STACK_LAYER_OFFSET = 4;
const STACK_LAYERS = 2;

export const PRODUCTS_ADDED_STACK_HEIGHT = STACK_LAYER_OFFSET * STACK_LAYERS;

const VISIBLE_LIST_ITEMS = 2.5;
const LIST_GAP = 0.75;
const LIST_SCROLLBAR_GAP = 1;

interface ProductsAddedCardStylesParams {
  mediaFormat: MediaFormatEnum;
}

export const useProductsAddedCardStyles = makeStyles<ProductsAddedCardStylesParams>()(
  (theme, { mediaFormat }) => ({
    cardStack: {
      position: 'relative',
      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: '100%',
        borderRadius: AVATAR_BORDER_RADIUS,
        border: `1px solid ${theme.palette.custom.border.primary}`,
        backgroundColor: theme.palette.background.paper,
      },
      '&::before': {
        transform: `translateY(${PRODUCTS_ADDED_STACK_HEIGHT}px) scaleX(0.92)`,
      },
      '&::after': {
        transform: `translateY(${STACK_LAYER_OFFSET}px) scaleX(0.96)`,
      },
      '& > *': {
        position: 'relative',
        zIndex: 1,
        backgroundColor: theme.palette.background.paper,
      },
    },
    clickableStack: {
      cursor: 'pointer',
    },
    closeIcon: {
      cursor: 'pointer',
      color: theme.palette.text.secondary,
    },
    expandedList: {
      gap: theme.spacing(LIST_GAP),
      maxHeight: `calc(${PRODUCTS_ADDED_CARD_HEIGHT[mediaFormat] * VISIBLE_LIST_ITEMS}px + ${theme.spacing(LIST_GAP * Math.floor(VISIBLE_LIST_ITEMS))})`,
      overflowY: 'auto',
      overscrollBehavior: 'contain',
      marginRight: theme.spacing(-LIST_SCROLLBAR_GAP),
      paddingRight: theme.spacing(LIST_SCROLLBAR_GAP),
    },
    colorName: {
      paddingLeft: theme.spacing(0.75),
    },
    avatarContainer: {
      width: AVATAR_WIDTH[mediaFormat],
      flexShrink: 0,
      borderTopLeftRadius: AVATAR_BORDER_RADIUS,
      borderBottomLeftRadius: AVATAR_BORDER_RADIUS,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      '& > img': {
        borderRadius: 0,
      },
    },
  }),
);
